import type { ComponentType } from "react";

import type { IWebsitesModal } from "../../components/modals/WebsitesModal/types";
import trackingService from "../../services/tracking/trackingService";

type HocProps = Partial<Pick<IWebsitesModal, "onListNameChange" | "onCloseProTipBanner">> & {
    isTrackingEnabled?: boolean;
};

const withOpportunityListModalTracked = <P extends HocProps>(Component: ComponentType<P>) => {
    return function WrappedWithListRenameTracking(props: P) {
        if (!props.isTrackingEnabled) {return <Component {...props} />;}

        function handleListNameChange(name: string): void {
            trackingService.manageList.trackListNameChanged(name);

            props.onListNameChange?.(name);
        }

        function handleCloseProTipBanner(): void {
            trackingService.manageList.trackDismissHelpClicked();

            props.onCloseProTipBanner?.();
        }

        return (
            <Component
                {...props}
                onListNameChange={handleListNameChange}
                onCloseProTipBanner={handleCloseProTipBanner}
            />
        );
    };
};

export default withOpportunityListModalTracked;
